<template>
  <section v-if="visible" class="cc" role="region" aria-label="Cookie consent">
    <p class="cc__text">
      We use cookies for analytics and advertising to improve Below MSRP. You can accept or
      deny them; the site works either way.
      <a href="https://www.belowmsrp.com/privacy" target="_blank" rel="noopener">Privacy Policy<span class="sr-only"> (opens in a new tab)</span></a>
    </p>
    <div class="cc__actions">
      <button type="button" class="cc__btn" @click="choose('denied')">Deny</button>
      <button type="button" class="cc__btn cc__btn--primary" @click="choose('accepted')">Accept</button>
    </div>
  </section>
</template>

<script>
// Choice lives in localStorage "cookieConsent". public/index.html loads GTM,
// Clarity and the Meta Pixel only when it is "accepted" (window.loadTrackers).
// It is also kept in a "bm_consent" cookie on .belowmsrp.com, so the choice
// survives logout (localStorage.clear) and is shared with www.belowmsrp.com.
const KEY = "cookieConsent";
const readCookie = () => (document.cookie.match(/(?:^|; )bm_consent=(granted|denied)/) || [])[1];
const writeCookie = (v) => {
  document.cookie = "bm_consent=" + v + "; max-age=31536000; path=/; SameSite=Lax" + (location.hostname.endsWith("belowmsrp.com") ? "; domain=.belowmsrp.com" : "");
};

export default {
  name: "CookieConsent",
  data() {
    return { visible: false };
  },
  mounted() {
    try {
      this.visible = !localStorage.getItem(KEY) && !readCookie();
    } catch (e) {
      this.visible = false;
    }
  },
  methods: {
    choose(value) {
      try {
        localStorage.setItem(KEY, value);
        writeCookie(value === "accepted" ? "granted" : "denied");
      } catch (e) {
        // private mode: choice lasts for this page view only
      }
      if (value === "accepted" && typeof window.loadTrackers === "function") window.loadTrackers();
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.cc {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 84px; /* clears the mobile bottom nav */
  z-index: 9000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  max-width: 760px;
  margin: 0 auto;
  padding: 14px 18px;
  border-radius: 14px;
  background: #0b1a2e;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  font-size: 14px;
  line-height: 1.5;
}
@media (min-width: 768px) {
  .cc {
    bottom: 16px;
  }
}
.cc__text {
  margin: 0;
  flex: 1 1 320px;
}
.cc__text a {
  color: #9cc4f8;
  text-decoration: underline;
}
.cc__actions {
  display: flex;
  gap: 10px;
}
.cc__btn {
  min-height: 44px;
  min-width: 88px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: transparent;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}
.cc__btn--primary {
  background: #2563cc;
  border-color: #2563cc;
}
</style>
